import { useState } from "react";
import { DateTime } from "luxon";
import isNull from "lodash/isNull";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import Menu from "@mui/material/Menu";
import CaretBottomIcon from "../../../icons/CaretBottom";
import CheckCircleIcon from "../../../icons/CheckCircle";
import colors from "../../../theme/colors";
import {
  getInitialsForUser,
  isoDateToDateTimeString,
} from "../../../utils/labels";
import ConditionCell from "../../../components/forms/ConditionCell";
import InputCell from "../../../components/forms/InputCell";

type Props = {
  className?: string;
  value?: ReferenceCalibration;
};

const ReferenceCalibrationCell = ({ className, value }: Props) => {
  const [checkButtonEl, setCheckButtonEl] = useState<null | HTMLButtonElement>(
    null
  );
  const handleCheckButtonClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    setCheckButtonEl(event.currentTarget);
  };
  const handleCheckButtonClose = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.stopPropagation();
    setCheckButtonEl(null);
  };

  if (!value || isNull(value.measurement)) {
    return <ConditionCell />;
  }

  const {
    preferred_executor_name,
    measurement,
    measured_at: measured_at_unix,
  } = value;
  const measured_at = DateTime.fromSeconds(measured_at_unix).toISO();

  const endAdornment = (
    <Box ml="auto" display="flex" alignItems="center">
      <IconButton size="small" onClick={handleCheckButtonClick}>
        <CheckCircleIcon
          style={{
            width: 20,
            height: 20,
            color: colors.accent.green,
          }}
        />
        <CaretBottomIcon
          style={{
            marginLeft: "0.5rem",
            width: 16,
            height: 16,
            color: colors.text.secondary,
            transform: !checkButtonEl ? "rotate(-90deg)" : undefined,
          }}
        />
      </IconButton>
    </Box>
  );

  return (
    <>
      <InputCell
        className={`${className} textPrimary componentCompleted`}
        disabled={true}
        value={measurement}
        endAdornment={endAdornment}
      />

      <Menu
        anchorEl={checkButtonEl}
        open={!!checkButtonEl}
        onClose={handleCheckButtonClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <ListItem>
          <Box display="flex" alignItems="center">
            <Avatar className="bg-cta">
              {getInitialsForUser({ name: preferred_executor_name } as User)}
            </Avatar>
            <Box ml={3} mr={2}>
              {preferred_executor_name}
            </Box>
            <Box color={colors.text.secondary}>
              {isoDateToDateTimeString(measured_at)}
            </Box>
          </Box>
        </ListItem>
      </Menu>
    </>
  );
};

export default ReferenceCalibrationCell;
